module.exports = __webpack_public_path__ + "img/slika6_2022.417f97e6.png";